"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppStateProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const store_1 = require("@completeanatomy/store");
const react_redux_1 = require("react-redux");
const typedi_1 = require("typedi");
/**
 * @todo think of exporting selectors for AppState
 */
/**
 * React component to provide app state
 *
 * @param children
 */
function AppStateProvider({ children }) {
    const store = typedi_1.Container.get(store_1.StoreToken);
    return (0, jsx_runtime_1.jsx)(react_redux_1.Provider, { store: store, "data-e2e": 'AppStateProvider_Provider', children: children });
}
exports.AppStateProvider = AppStateProvider;
